import { t } from 'i18next';
import styles from './styles.module.scss';
import { FAVORITE_PRODUCT_URL } from 'utils/constants';

function EditFavoriteProduct() : JSX.Element {
  return (
    <div id='biobar-edit-favorite-product' className={styles['biobar-edit-favorite-product']}>
      <a href={`${FAVORITE_PRODUCT_URL}/edit`}>{t('biobar.profile.favoriteproduct.a')}</a>
    </div>
  );
}

export default EditFavoriteProduct;